import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const JourneyPanel = ({ data,
    getPushedSkuListData,
    page
 }) => {

  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState("pending");
  const [pushedData, setPushedData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [loading,setLoading] = useState({});

  useEffect(() => {
    let pushed = [];
    let pending = [];
    data.map((item) => {
      if (item.status === "pushed") {
        pushed.push(item);
      } else {
        pending.push(item);
      }
    });

    setPendingData(pending);
    setPushedData(pushed);
  }, [data]);


  const pushedToShopify = async (id,isPushAll,index) => {
    
    try {
        if(loading[index]){
            return
        }
        let url;
        if(isPushAll){
            url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/pushed-to-shopify?isPushAll=${true}&page=${page}`;
        }else{
           url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/pushed-to-shopify?pushed_shopify_id=${id}`;
        }
      
      setLoading((old)=>{
        return {
          ...old,
          [index]: true
        }
      })
      const response = await axios.put(
        url,
        {}, // Put an empty object if there's no data to send
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      getPushedSkuListData()
  
      toast.success("Pushed Successfully!");
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      console.error("Push failed:", error);
      toast.error("Push failed.");
    }finally{
      setLoading((old)=>{
        return {
          ...old,
          [index]: true
        }
      })
    }
  };

  const renderTable = (tableData, isPushed) => (
    <div className="w-full overflow-x-auto mt-4 rounded-lg shadow-md">
      <table className="w-full text-sm text-left text-gray-700 bg-white border border-gray-200">
        <thead className="bg-gray-100 text-xs text-gray-600 uppercase tracking-wider">
          <tr>
            <th className="px-4 py-3 border-b">Main SKU</th>
            <th className="px-4 py-3 border-b">Along With SKU</th>
            <th className="px-4 py-3 border-b">Status</th>
            {!isPushed && <th className="px-4 py-3 border-b">Action</th>}
          </tr>
        </thead>
        <tbody>
          {tableData.length === 0 && (
            <tr>
              <td colSpan={isPushed ? 3 : 4} className="px-4 py-6 text-center text-gray-400">
                No records found.
              </td>
            </tr>
          )}
          {tableData.map((item, idx) => (
            <tr key={idx} className="hover:bg-gray-50 transition-all">
              <td className="px-4 py-3 border-b font-medium text-blue-700">{item.mainSku}</td>
              <td className="px-4 py-3 border-b">
                <div className="flex flex-wrap gap-1">
                  {item.pushedSkuDetails.map((i, iIdx) => (
                    <span key={iIdx} className="inline-block bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs font-medium">
                      {i.sku}
                    </span>
                  ))}
                </div>
              </td>
              <td className="px-4 py-3 border-b capitalize">{item.status}</td>
              {!isPushed && (
                <td className="px-4 py-3 border-b">
                  <button
                    onClick={() => pushedToShopify(item._id,"",idx)}
                    className="text-sm px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 transition"
                  >
                    {
                        loading[idx] ? "Please wait.." : "Push to Shopify"
                    }
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="w-full p-4  rounded-xl ">
      <div className="flex space-x-4 border-b pb-3">
        {["pending", "pushed"].map((tab) => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            className={`px-5 py-2 text-sm font-medium rounded-t-md transition-all duration-200 ${
              selectedTab === tab
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {tab === "pending" ? "Pending" : "Pushed"}
          </button>
        ))}
      </div>
      {
        pendingData.length > 1 && selectedTab === "pending" &&
        <div className="flex justify-end my-3">
        <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        onClick={()=>{
            pushedToShopify("",true)
        }}
        >
        Push All
        </button>
    </div>
      }

      {selectedTab === "pending" && renderTable(pendingData, false)}
      {selectedTab === "pushed" && renderTable(pushedData, true)}
    </div>
  );
};

export default JourneyPanel;
